import React, { useState, useEffect } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import toast, { Toaster } from "react-hot-toast";

//Components
import Listado from "../../components/lists/Listado";
import CrearSolicitudButton from "../../components/buttons/crearSolicitudButton";

//Componentes
import Loading from "../../components/modales/loadingModal";
import LoadingTransparent from "../../components/modales/loadingModalTransparent";
import ModalInformacionRetiro from "./componentes/modalInformacionRetiro";
import ModalCreacionRetiro from "./componentes/modalCreacionRetiro";
//Redux
import { connect } from "react-redux";

//API Calls
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";
const getListadoRetiros = functionsHttpsCallable("ape_listadoRetiros");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const GestorRetiro = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [activeId, setActiveId] = useState();
  const [activeName, setActiveName] = useState();
  const [campo, setCampo] = useState("");
  const [campoBusqueda, setCampoBusqueda] = useState("");
  const [data, setData] = useState([]);
  const [retirosFiltrados, setRetirosFiltrados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);
  const [modalCreacion, setModalCreacion] = useState(false);
  const [userId, setUserId] = useState(parseInt(userData.userId));

  useEffect(() => {
    setInitialData();
  }, []);

  useEffect(() => {
    handleBusqueda();
  }, [campoBusqueda]);

  const handleBusqueda = () => {
    let solicitudesPropias = data.length ? data : [];
    let solicitudesPropiasTemp;
    if (campoBusqueda !== "" && campoBusqueda !== undefined) {
      if (campo === "text") {
        solicitudesPropiasTemp = solicitudesPropias.length
          ? solicitudesPropias.filter((solicitud) =>
              solicitud[campo].includes(campoBusqueda.toUpperCase())
            )
          : [];
      } else if (campo === "cedula") {
        solicitudesPropiasTemp = solicitudesPropias.length
          ? solicitudesPropias.filter((solicitud) =>
              solicitud[campo].toString().includes(campoBusqueda)
            )
          : [];
      } else {
        solicitudesPropiasTemp = data.length ? data : [];
      }
    } else {
      solicitudesPropiasTemp = data.length ? data : [];
    }
    setRetirosFiltrados(solicitudesPropiasTemp);
  };

  const setInitialData = async () => {
    setLoading(true);
    const body = {
      cod_empl: userId,
    };
    const listadoRetiros = await getListadoRetiros(body);

    setData(
      listadoRetiros.data.data.map((item, index) => {
        return {
          id: item.retiroId,
          cedula: item.cedulaRetiro,
          text: item.nombre,
          state: item.estado,
          color: "info",
          customIcon:
            item.estado === "FINALIZADO" ? "FaCheck" : "FaExclamation",
        };
      })
    );
    setRetirosFiltrados(
      listadoRetiros.data.data.map((item, index) => {
        return {
          id: item.retiroId,
          cedula: item.cedulaRetiro,
          text: item.nombre,
          state: item.estado,
          color: "info",
          customIcon:
            item.estado === "FINALIZADO" ? "FaCheck" : "FaExclamation",
        };
      })
    );
    setLoading(false);
  };

  const handleToggle = (solicitud) => {
    setActiveId(solicitud.id);
    setActiveName(solicitud.text);
    toggleModalInfo();
  };
  const renderModalInformacion = () => {
    if (activeId !== undefined) {
      return (
        <ModalInformacionRetiro
          modal={modalInfo}
          toggle={() => {
            toggleModalInfo();
          }}
          id={activeId}
          text={activeName}
          success={(e) => {
            toastSuccess(e);
          }}
          error={(e) => {
            toastError(e);
          }}
        />
      );
    } else return <></>;
  };
  const renderModalCreacion = () => {
    return (
      <ModalCreacionRetiro
        modal={modalCreacion}
        toggle={() => {
          toggleCreacion();
        }}
        setLoading={(e) => {
          setLoading(e);
        }}
        id={activeId}
        text={activeName}
        toastSuccess={(e) => {
          toastSuccess(e);
        }}
        toastError={(e) => {
          toastError(e);
        }}
      />
    );
  };

  const toggleModalInfo = () => setModalInfo((prevModalInfo) => !prevModalInfo);
  const toggleCreacion = () => setModalCreacion(!modalCreacion);
  return loading ? (
    <div className={"loading-area"}>
      <Loading />
    </div>
  ) : (
    <>
      <Toaster />
      <LoadingTransparent isOpen={modalTransaction} />
      {renderModalInformacion()}
      {renderModalCreacion()}
      <Breadcrumb>
        <BreadcrumbItem className="breadcum-display-content" active>
          Listado Retiros
          <CrearSolicitudButton
            onClick={() => {
              console.log("aca");
              toggleCreacion();
            }}
          />
        </BreadcrumbItem>
      </Breadcrumb>
      <Card>
        <CardBody>
          <Row>
            <Col lg="10" md="8" xs="12">
              <TextField
                required
                autoComplete="off"
                key={`key_busqueda`}
                id={`input_busqueda`}
                fullWidth
                label={"Busqueda"}
                onChange={(e) => setCampoBusqueda(e.target.value)}
                defaultValue=""
                margin="normal"
              />
            </Col>
            <Col lg="2" md="4" xs="12">
              <Autocomplete
                required
                margin="dense"
                options={[
                  { label: "Nombre", value: "text" },
                  { label: "Cédula", value: "cedula" },
                ]}
                key={`key_Cargo`}
                id={`select_Cargo`}
                onChange={(event, newValue) => setCampo(newValue.value)}
                renderInput={(params) => (
                  <TextField {...params} label={"Campo"} margin="normal" />
                )}
                getOptionLabel={(option) => option.label}
                renderOption={(option) => (
                  <React.Fragment>{option.label}</React.Fragment>
                )}
              />
            </Col>
          </Row>
          <Listado
            listaSolicitudes={retirosFiltrados}
            onClick={(e) => {
              handleToggle(e);
            }}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default connect(mapStateToProps)(GestorRetiro);
